/**
 * Testimonials Data
 * Customer reviews and testimonials
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const testimonials = [
  {
    id: "1",
    headline: "Just feel more balanced",
    review:
      "I used Naori to support my weight loss journey but it gave me much more. I finally feel balanced - less cravings, no mood swings, no bloating.",
    name: "Tina R.",
    image: `${assetsUrl}img/review-5.webp`,
  },
  {
    id: "2",
    headline: "Sceptical at first, now I'm influenced",
    review:
      "A friend influenced me to try, now I'm on subscription. From the first bottle, it helped me burn the unwanted body weight and feel so much lighter!",
    name: "Nichole E.",
    image: `${assetsUrl}img/review-6.webp`,
  },
  {
    id: "3",
    headline: "I can finally eat whatever I want",
    review:
      "No matter what I ate, I always felt bloated and heavy. Now I can eat whatever I want without upsetting my stomach.",
    name: "Laura U.",
    image: `${assetsUrl}img/review-1.webp`,
  },
  {
    id: "4",
    headline: "Big difference from the start",
    review:
      "I've tried the cheap probiotics from the drug store and felt nothing. Naori is definitely stronger as I noticed a difference in my digestion within three days.",
    name: "Jessica E.",
    image: `${assetsUrl}img/review-2.webp`,
  },
  {
    id: "5",
    headline: "No more rebound weight",
    review:
      "It's a shame to admit but I used to cover the mirrors every time I gained weight. Not only did Naori helped me lose the unwanted fat but it also stabilized the scale! No more rebound weight!",
    name: "Sandra T.",
    image: `${assetsUrl}img/review-3.webp`,
  },
  {
    id: "6",
    headline: "I finally fit in my jeans",
    review:
      "I can finally button my jeans after dinner without feeling like I'm going to pop. The evening bloat is just... gone. It's such a relief.",
    name: "Anna T.",
    image: `${assetsUrl}img/review-4.webp`,
  },
];

export default testimonials;
